import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle"]
  static values = { storageKey: { type: String, default: "dwm:sidebar-collapsed" } }

  connect() {
    this.applyState(this.savedCollapsed())
  }

  toggle() {
    const collapsed = !document.body.classList.contains("dwm-sidebar-collapsed")
    this.applyState(collapsed)
    this.saveCollapsed(collapsed)
  }

  applyState(collapsed) {
    const actionLabel = collapsed ? "Expand navigation" : "Collapse navigation"
    const expanded = collapsed ? "false" : "true"

    document.body.classList.toggle("dwm-sidebar-collapsed", collapsed)
    this.element.setAttribute("aria-expanded", expanded)
    this.toggleTargets.forEach((toggle) => {
      toggle.setAttribute("aria-expanded", expanded)
      toggle.setAttribute("aria-label", actionLabel)

      if (toggle.hasAttribute("title")) {
        toggle.setAttribute("title", actionLabel)
      }
    })
    this.element.querySelectorAll("[data-dwm-sidebar-label]").forEach((label) => {
      label.setAttribute("aria-hidden", collapsed ? "true" : "false")
    })
  }

  savedCollapsed() {
    try {
      return localStorage.getItem(this.storageKeyValue) === "true"
    } catch {
      return false
    }
  }

  saveCollapsed(collapsed) {
    try {
      localStorage.setItem(this.storageKeyValue, collapsed ? "true" : "false")
    } catch {
      return
    }
  }
}
